import { useContext, useEffect, useState, useMemo } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import {
    STR_MEMBERS,
    STR_NO_RECORD,
    STR_SEARCH_HERE,
} from "../Strings";
import { MdSearch, MdPeopleOutline } from 'react-icons/md';
import OneMember from "../ones/OneMember";

export default function View(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);
    const [filter, setFilter] = useState("");

    async function init() {
        setReady(false);
        await Promise.all([appContext.getMembers()]);
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    // Optimized filtering using useMemo
    const filteredMembers = useMemo(() => {
        const list = appContext.members || [];
        if (!filter) return list;
        return list.filter(item => 
            String(item.fullname).toLowerCase().includes(filter.toLowerCase())
        );
    }, [appContext.members, filter]);

    if (!ready) {
        return (
            <div className="vh-100 d-flex align-items-center justify-content-center bg-white">
                {getInlineLoader()}
            </div>
        );
    }

    return (
        <div 
            className="mNoScrollBar" 
            style={{ 
                width: "100%", 
                height: "100%", 
                overflowY: "auto", 
                backgroundColor: "#f8fafc",
                paddingBottom: "100px" 
            }}
        >
            <style>{`
                .sticky-header {
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    background: rgba(248, 250, 252, 0.8);
                    backdrop-filter: blur(12px);
                    -webkit-backdrop-filter: blur(12px);
                    padding: 20px 0 10px 0;
                    border-bottom: 1px solid rgba(0,0,0,0.05);
                }
                .search-wrapper {
                    transition: all 0.3s ease;
                    border: 1px solid #e2e8f0;
                    background: white;
                }
                .search-wrapper:focus-within {
                    border-color: var(--primaryColor);
                    box-shadow: 0 0 0 4px rgba(var(--primaryColorRGB), 0.1);
                    transform: translateY(-1px);
                }
                .member-card-anim {
                    opacity: 0;
                    transform: translateY(15px);
                    animation: fadeInUp 0.5s ease forwards;
                }
                @keyframes fadeInUp {
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            {/* Header Section */}
            <div className="sticky-header">
                <div className="container">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>
                            <h4 className="font-bold text-primary mb-0">
                                {STR_MEMBERS[appContext.language]}
                            </h4>
                            <p className="small text-muted mb-0 fw-medium">
                                {appContext.members?.length || 0} Registered Members
                            </p>
                        </div>
                        <div className="bg-white p-2 rounded-circle shadow-sm border">
                            <MdPeopleOutline size={24} className="text-primary" />
                        </div>
                    </div>

                    {/* Search Bar */}
                    <div className="search-wrapper d-flex align-items-center px-3 rounded-pill mb-2">
                        <MdSearch size={22} className="text-muted" />
                        <input
                            className="form-control border-0 bg-transparent ps-2 py-2"
                            onChange={(e) => setFilter(e.target.value)}
                            value={filter}
                            placeholder={STR_SEARCH_HERE[appContext.language]}
                            style={{ boxShadow: 'none', fontSize: '15px', fontWeight: '500' }}
                        />
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="container mt-3">
                <div className="row g-3">
                    {filteredMembers.length > 0 ? (
                        filteredMembers.map((item, i) => (
                            <div 
                                className="col-12 member-card-anim" 
                                key={item.id || i}
                                style={{ animationDelay: `${i * 50}ms` }}
                            >
                                <OneMember data={item} />
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center py-5">
                            <div className="opacity-50 mb-3">
                                <MdSearch size={48} />
                            </div>
                            <h6 className="text-muted fw-light">
                                {STR_NO_RECORD[appContext.language]}
                            </h6>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}